import { Box, ErrorBoundary, Skeleton } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { LocaleSelection } from "../../app/components/locales/LocaleSelection"
import { useDocumentListLocales } from "../useDocumentListLocales"

export function DocumentListLocales() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LocalesSkeleton />}>
        <DocumentListLocalesContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function DocumentListLocalesContent() {
  const { locale, langs, updateLocale } = useDocumentListLocales()

  return (
    <Box flexShrink={0} flexDirection="column">
      <LocaleSelection
        locale={{ id: locale, customName: null }}
        onLocaleChange={({ id }) => updateLocale(id)}
        locales={langs}
      />
    </Box>
  )
}

function LocalesSkeleton() {
  return <Skeleton height={40} />
}
